var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.33,
    height: 40.33,
    viewBox: "0 0 40.33 40.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135350",
    "data-name": "Group 135350",
    transform: "translate(-18026.947 -2841.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6008",
    "data-name": "Rectangle 6008",
    d: "M2.976-.75H35.854A3.73,3.73,0,0,1,39.58,2.976V35.854a3.73,3.73,0,0,1-3.726,3.726H2.976A3.73,3.73,0,0,1-.75,35.854V2.976A3.73,3.73,0,0,1,2.976-.75Zm32.878,38.4a1.8,1.8,0,0,0,1.795-1.795V2.976a1.8,1.8,0,0,0-1.795-1.795H2.976A1.8,1.8,0,0,0,1.181,2.976V35.854a1.8,1.8,0,0,0,1.795,1.795Z",
    transform: "translate(18027.697 2842.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1150",
    "data-name": "Ellipse 1150",
    d: "M5.023-.75A5.773,5.773,0,1,1-.75,5.023,5.779,5.779,0,0,1,5.023-.75Zm0,9.615A3.842,3.842,0,1,0,1.181,5.023,3.846,3.846,0,0,0,5.023,8.865Z",
    transform: "translate(18042.475 2856.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_171",
    "data-name": "Line 171",
    d: "M.216,8.347A.966.966,0,0,1-.75,7.381V.216a.966.966,0,0,1,1.931,0V7.381A.966.966,0,0,1,.216,8.347Z",
    transform: "translate(18047.283 2849.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_172",
    "data-name": "Line 172",
    d: "M.216,8.347A.966.966,0,0,1-.75,7.381V.216a.966.966,0,0,1,1.931,0V7.381A.966.966,0,0,1,.216,8.347Z",
    transform: "translate(18047.283 2866.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_173",
    "data-name": "Line 173",
    d: "M7.381,1.181H.216a.966.966,0,0,1,0-1.931H7.381a.966.966,0,0,1,0,1.931Z",
    transform: "translate(18052.09 2861.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91136",
    "data-name": "Path 91136",
    d: "M97.681,32.241a12.825,12.825,0,0,1-7.758-2.584,13.045,13.045,0,0,1-4.609-6.549.966.966,0,1,1,1.846-.567,11,11,0,1,0,0-6.491.966.966,0,0,1-1.845-.57A13.051,13.051,0,0,1,89.93,8.943a12.938,12.938,0,1,1,7.75,23.3Z",
    transform: "translate(17949.818 2842.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1151",
    "data-name": "Ellipse 1151",
    d: "M3.746-.75a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,3.746-.75Zm0,7.06A2.565,2.565,0,1,0,1.181,3.746,2.567,2.567,0,0,0,3.746,6.31Z",
    transform: "translate(18032.053 2858.162)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLI3);
export default __webpack_public_path__ + "static/media/l-i-3.335ef0f99a7f85557da53097a9c1854b.svg";
export { ForwardRef as ReactComponent };